<script>
  import { onMount, onDestroy, createEventDispatcher } from "svelte";
  import { fly } from "svelte/transition";
  import { ScrollingDisable, ScrollingEnable } from "../library/util.js";
  import RestStripe from "../components/RestStripe.svelte";
  import MyModal from "../components/MyModal.svelte";
  import { loadStripe } from "@stripe/stripe-js";
  import StripeForm from "../components/StripeForm.svelte";

  const dispatch = createEventDispatcher();
  let restStripe = null;
  let myModal = null;
  let busy = true;
  let stripe = null;
  let stripeConfig = null;

  onMount(async () => {
    ScrollingDisable();

    try {
      busy = true;

      // get stripe config
      stripeConfig = await restStripe.GetConfig();

      // load stripe
      stripe = await loadStripe(stripeConfig.clientkey);

      busy = false;
    } catch (error) {
      busy = false;

      switch (error) {
        case "BadRole":
        case "BadRealm":
          appSession.set({ authorisationToken: null, pilotId: null });
          break;
        case "NetworkError":
          myModal.showAlert(
            "Network error",
            "A network error occurred.<p> Check network connection and try again.</p>"
          );
          break;
        default:
          myModal.showAlert("Error", error);
          break;
      }
    }
  });

  onDestroy(() => {
    ScrollingEnable();
  });

  async function updateCreditCard(event) {
    event.detail.event.preventDefault();
    if (!event.detail.cardComplete) return;

    try {
      busy = true;

      // create payment method
      let paymentMethod = await stripe.createPaymentMethod({ type: "card", card: event.detail.cardElement });
      if (typeof paymentMethod.error !== "undefined") throw paymentMethod.error.message;

      let cardUpdatedOk = await restStripe.PostCreditcard(paymentMethod.paymentMethod.id);

      setTimeout(() => {
        M.toast({ html: "Your card has been updated" }, { displayLength: 3000 });
      }, 500);

      busy = false;

      dispatch("close", { didUpdate: cardUpdatedOk });
    } catch (error) {
      busy = false;

      switch (error) {
        case "BadRole":
        case "BadRealm":
          appSession.set({ authorisationToken: null, pilotId: null });
          break;
        case "NetworkError":
          myModal.showAlert(
            "Network error",
            "A network error occurred.<p> Check network connection and try again.</p>"
          );
          break;
        default:
          let alertError = "<p>Sorry the following error was generated while processing your subscription:</p>";
          alertError += "<p>" + error + "</p>";
          alertError += "<p>Please check your credit card details and try again.</p>";
          myModal.showAlert("Error", alertError);
          break;
      }
    }
  }
</script>

<div class="overlay-page-wrapper" transition:fly={{ y: 200, duration: 500 }}>
  <div class="overlay-page-header valign-wrapper">
    <div class="container">
      <div class="row">
        <div class="col s10 offset-s1">
          <h5 class="center-align">Update card</h5>
        </div>
      </div>
    </div>
  </div>

  <div class="overlay-page-body">
    <div class="container">
      {#if stripe}
        <p><b>Enter new credit card details:</b></p>

        <div style="margin-top: 20px;">
          <StripeForm
            {stripe}
            goButtonText="Update"
            showCancel={false}
            disabled={busy}
            on:submit={(evt) => {
              updateCreditCard(evt);
            }} />
        </div>
      {/if}

      {#if busy}
        <div
          style="display: flex; justify-content: center; align-items: center; height: 50px; width: 100%; margin-top: 50px;">
          <div class="preloader-wrapper small active">
            <div class="spinner-layer spinner-green-only">
              <div class="circle-clipper left">
                <div class="circle" />
              </div>
              <div class="gap-patch">
                <div class="circle" />
              </div>
              <div class="circle-clipper right">
                <div class="circle" />
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>

  <div class="overlay-page-footer">
    <div class="container">
      <div class="right">
        <button
          class="waves-effect btn blue-grey"
          on:click={() => {
            dispatch('close', { didUpdate: false });
          }}>
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>

<RestStripe bind:this={restStripe} />
<MyModal bind:this={myModal} />
